import { useMutation, gql } from '@apollo/client';

import { GET_NOTIFICATIONS } from './get-notifications.hook';

export const READ_ALL_NOTIFICATIONS = gql`
  mutation readAllNotifications {
    readAllNotifications
  }
`;

export const useReadAllNotifications = () => {
  const [mutate] = useMutation(READ_ALL_NOTIFICATIONS, {
    refetchQueries: [GET_NOTIFICATIONS],
  });

  return mutate;
};
